
export function massInvitationModalInit() {
  // We always render mass invitation modals on page load
  $('#mass-invitation-modal').modal('show')
}